import React from 'react';
import SatInput from '@components/common/satUI/SatInput';
import SatDatePicker from '@components/common/satUI/SatDatePicker';

const UseSearch = props => {
    const {
        handleCalculateDate,
        dayHandler,
        weekHandler,
        monthHandler,
        yearHandler,
        handleAplctnDvcTyCd,
        handleChangeOrgChnlCdSelect,
        handleInputEvent,
        codeList,
        searchInfo,
        hqList,
        agencyList,
        search
      } = props;

      return (
        <React.Fragment>
            <div className="search-box">
                <div className="data-group-left">
                    <div className="data-area">
                        <span className="data-tit">기간 검색</span>
                        <SatDatePicker
                            value={searchInfo.searchStartDate} 
                            disabledDates={['2021-09-28']}
                            onChange={e => handleCalculateDate(e, 'from')}
                            viewIcon={true}
                        />
                        <span className="tilde">~</span>
                        <SatDatePicker
                            value={searchInfo.searchEndDate} 
                            disabledDates={['2021-09-28']}
                            onChange={e => handleCalculateDate(e, 'to')}
                            viewIcon={true}
                        />
                        <button className="btn-day" onClick={() => dayHandler('use')}>일간</button>
                        <button className="btn-week" onClick={() => weekHandler('use')}>주간</button>
                        <button className="btn-month" onClick={() => monthHandler('use')}>월간</button>
                        <button className="btn-year" onClick={() => yearHandler('use')}>연간</button>
                    </div>
                </div>
                <div>                    
                    <div className="data-group-left">
                        <div className="data-area">
                            <span className="data-tit">채널</span>
                            <div className="sel-group">
                                <select id='selectChnlId' onChange={handleChangeOrgChnlCdSelect} value={searchInfo.orgChnlCd}>
                                    <option value="">전체</option>
                                    {codeList.map(option => (
                                        <option value={option.cdVal} key={option.cdVal}>{option.cmnCdNm}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="data-group-left">
                        <div className="data-area">
                            <span className="data-tit">본부</span>
                            <div className="sel-group sel-wide">
                                <select id='selectHqId' onChange={handleChangeOrgChnlCdSelect} value={searchInfo.hqId}>
                                    <option value="">전체</option>
                                    {hqList.map(option => (
                                        <option value={option.hqCd} key={option.hqCd}>{option.hqNm}</option>
                                     ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="data-group-left">
                        <div className="data-area">
                            <span className="data-tit">지점</span>
                            <div className="sel-group sel-wide">
                                <select id='selectAgncId' onChange={handleChangeOrgChnlCdSelect} value={searchInfo.agncCd}>
                                    <option value="">전체</option>
                                    {agencyList.map(option => (
                                        <option value={option.agncCd} key={option.agncCd}>{option.agncNm}</option>
                                     ))}
                                </select>
                            </div>
                        </div>
                    </div>                    
                </div>
                <button className="btn-search" onClick={() => search()}>조회</button>
            </div>
        </React.Fragment>
      );
      
};

export default UseSearch;